export const warehouseQueryKey = {
  WAREHOUSES: "warehouses",
  WAREHOUSE_GROUP: "warehouse-group",
  WAREHOUSE_GROUP_DETAIL: "warehouse-group-detail",
  PART_NG: "part-ng",
  NOTIFICATIONS: "notifications",
  WAREHOUSE_EXPORTS: "warehouse-exports",
  QUANTITY_EXPORT: "quantity-export",
  WAREHOUSES_PROJECT: "warehouses-by-project",
  WAREHOUSE_LOCATIONS: "warehouse-locations",
  WAREHOUSE_EXPORT_TRANSFERS: "warehouse-export-transfer",
  WAREHOUSE_TRANSFERS: "warehouse-transfer",
  WAREHOUSE_TRANSFER_DETAIL: "warehouse-transfer-detail",
  WAREHOUSE_RETURN: "warehouse-return",
  WAREHOUSE_RETURN_DETAIL: "warehouse-return-detail",
  WAREHOUSE_GROUP_RESTOCK: "warehouse-group-restock",
};

export const userQueryKey = {
  USER_SYSTEM: "user-system",
  USERS_WITH_FILTERS: "users-with-filters",
  CREATE_USER: "create-user",
  PERMISSIONS_BY_USER: "permissions-by-user",
};

export const departmentQueryKey = {
  DEPARTMENTS: "departments",
  DEPARTMENT: "department",
};

export const trackingQueryKey = {
  DHL_TRACKING: "dhl-tracking",
  FEDEX_TRACKING: "fedex-tracking",
  DHL_TRACKINGS: "dhl-trackings",
  SHIPMENTS_INFO: "shipment-info",
  AWB: "awb",
  AWB_DETAIL: "awb-detail",
};

export const partNumberHistoryQueryKey = {
  PART_NUMBER_HISTORY: "part-number-history",
};

export const timesheetQueryKey = {
  TIMESHEET: "timesheet",
  EXTERNAL_EMPLOYEES: "external-employees",
};

export const employeeQueryKey = {
  EMPLOYEES_WITH_FILTERS: "employees-with-filters",
  EMPLOYEE_BY_ID: "employee-by-id",
  EMPLOYEE_WITHOUT_USER: "employee-without-user",
};

export const attendanceQueryKey = {
  ATTENDANCES: "attendances",
  ATTENDANCES_SOLVE: "attendances_solve",
  ATTENDANCES_WITH_FILTERS: "attendances-with-filters",
  ATTENDANCE_BY_ID: "attendance-by-id",
  ATTENDANCE_BY_EMPLOYEE: "attendance-by-employee",
  ATTENDANCE_TIMESHEET: "attendance-timesheet",
  ME: "attendance-me",
};
export const leaveRequestQueryKey = {
  LEAVE_REQUESTS: "leave-requests",
  LEAVE_REQUESTS_BY_EMPLOYEE: "leave-requests-by-employee",
  MY_LEAVE_REQUESTS: "my/leave-requests",
  LEAVE_REQUEST_BY_ID: "leave-request-by-id",
  CREATE_LEAVE_REQUEST: "create-leave-request",
  CANCEL_LEAVE_REQUEST: "cancel-leave-request",
  REVIEW_LEAVE_REQUEST: "review-leave-request",
};
export const overtimeRequestQueryKey = {
  OVERTIME_REQUESTS: "overtime-requests",
  OVERTIME_REQUESTS_BY_EMPLOYEE: "overtime-requests-by-employee",
  OVERTIME_REQUEST_BY_ID: "overtime-request-by-id",
  CREATE_OVERTIME_REQUEST: "create-overtime-request",
  UPDATE_OVERTIME_REQUEST: "update-overtime-request",
  CANCEL_OVERTIME_REQUEST: "cancel-overtime-request",
  REVIEW_OVERTIME_REQUEST: "review-overtime-request",
};
export const stationeryQueryKey = {
  STATIONERY_PERIOD: "stationery-period",
  STATIONERY_PRODUCT: "stationery-product",
  STATIONERY_CATEGORY: "stationery-categories",
  STATIONERY_REQUEST: "stationery-request",
};

export const meetingQueryKey = {
  GET_ALL_MEETING_SCHEDULE: "get-all-meeting-schedule",
  GET_MY_MEETING_SCHEDULE: "get-my-meeting-schedule",
  GET_MEETING_SCHEDULE_BY_ID: "get-meeting-schedule-by-id",

  CREATE_MEETING_SCHEDULE: "create-meeting-schedule",
  UPDATE_MEETING_SCHEDULE: "update-meeting-schedule",
  REVIEW_MEETING_SCHEDULE: "review-meeting-schedule",
  DELETE_MEETING_SCHEDULE: "delete-meeting-schedule",

  GET_ALL_MEETING_ROOM: "get-all-meeting-room",
  GET_MEETING_ROOM_BY_ID: "get-meeting-room-by-id",

  CREATE_MEETING_ROOM: "create-meeting-room",
  UPDATE_MEETING_ROOM: "update-meeting-room",
  DELETE_MEETING_ROOM: "delete-meeting-room",
};
